import QueryString from 'query-string';
import { FetchService } from '.';

export default class NotificationService extends FetchService {
  constructor() {
    super();

    this.get = this.get.bind(this);
    this.readAll = this.readAll.bind(this);
  }

  get(query = {}) {
    return this.Get('/notifications?' + QueryString.stringify(query), { cache: 'no-store' })
      .then((result) => {
        return Promise.resolve(result);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  readAll() {
    return this.Post('/notifications/all/read', {})
      .then((result) => {
        return Promise.resolve(result);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}
